/** Hiding a page (and everything under it) from the AI: the `ai: never` property. */
import { AI_PROP, blocksAi } from '@nexus/ai';
import type { Store } from '@nexus/store';
import { useStoreQuery } from '../db/context';

/** `own`: marked itself; `inherited`: under a marked page. */
export function useAiHidden(pageId: string) {
  return useStoreQuery(
    async (s) => {
      const own = blocksAi(await s.getProps(pageId));
      let inherited = false;
      let parent = (await s.getPage(pageId))?.parentId ?? null;
      for (let depth = 0; parent && !inherited && depth < 100; depth++) {
        inherited = blocksAi(await s.getProps(parent));
        parent = (await s.getPage(parent))?.parentId ?? null;
      }
      return { own, inherited };
    },
    [pageId],
    ['props', 'pages'],
  );
}

export async function setAiHidden(store: Store, pageId: string, hidden: boolean): Promise<void> {
  const props = await store.getProps(pageId);
  // Imported pages may spell it "AI"; change that property rather than adding one.
  const key = Object.keys(props).find((k) => k.toLowerCase() === AI_PROP) ?? AI_PROP;
  await store.setProp(pageId, key, hidden ? 'never' : undefined);
}
